import { create } from 'zustand';

const useUserLocationStore = create((set) => {
  // Retrieve the last selected city from localStorage or use a default value
  const storedCity = localStorage.getItem('userSelectedCity');
  const initialCity = storedCity ? JSON.parse(storedCity) : { name: null, coords: [0, 0] };

  return {
    // Store for the selected city (with both name and coordinates)
    userSelectedCity: initialCity,

    // Store for the user's current location (e.g., GPS-based)
    userNowLocation: { latitude: null, longitude: null },

    // Update selected city with full object (name and coords) and persist it
    setUserSelectedCity: (city) => {
      set({ userSelectedCity: city });
      localStorage.setItem('userSelectedCity', JSON.stringify(city)); // Save to localStorage
    },

    // Update user's current location with latitude and longitude
    setUserNowLocation: (location) => set({ userNowLocation: location }),
  };
});

export default useUserLocationStore;
